import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import { observer, inject } from 'mobx-react'
import { getUrlParam } from '@utils'

import LeftLogo from '../components/LeftLogo'
import LoginForm from './OneLoginForm'
import loginStyles from './styles/LoginStyle'
import { IProps as ILoginProps, IKnowledgeTheme } from '../Login'
import knowledgeC_bg from '@images/login/knowledgeC_bg.png'
import { transform } from '@utils/intl_lang'

interface IProps extends ILoginProps, WithStyles<typeof loginStyles> {}

@inject('UserStore', 'AppStore')
@observer
class Login extends React.Component<IProps, any> {
  public render() {
    const { classes, ...props } = this.props
    const route = getUrlParam('route')
    let knowledgeTheme = {} as IKnowledgeTheme
    if (route.includes('knowledge-cloud')) {
      knowledgeTheme = {
        platformName: transform('zhiniao_cloud'), // e祺学知识云
        coverImg: knowledgeC_bg,
      }
    }
    return (
      <div className={classes.login}>
        <LeftLogo
          AppStore={props.AppStore}
          coverImg={knowledgeTheme.coverImg || ''}
        />
        <LoginForm {...props} platformName={knowledgeTheme.platformName} />
      </div>
    )
  }
}

export default withStyles(loginStyles)(Login)
